/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import {
  Checkbox,
  Tooltip,
  Upload,
  message,
  DatePicker,
  Input,
  Card,
  ConfigProvider,
  Table,
  Button,
  Tag,
  Space,
} from "antd";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TranslateString } from "Utils/Common";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  EyeOutlined,
  UploadOutlined,
  LoadingOutlined,
  DownloadOutlined,
  CloseOutlined,
  FilePdfOutlined,
  FileImageOutlined,
  FileOutlined,
  CloseSquareOutlined,
} from "@ant-design/icons";
import type { UploadProps } from "antd";
import UserService from "services/UserService";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import { downloadContract, downloadMarketingMaterial } from "assets/images";
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import { useIntl } from "react-intl";
import "moment/locale/fi";

import { Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AiOutlineFilePdf } from "react-icons/ai";

const FileHandle = (props: any) => {
  const [fileLoading, setFileLoading] = useState<boolean>(false);

  const propsFile: UploadProps = {
    disabled: props?.tenderCase === "close",
    name: "file",
    action: `${process.env.REACT_APP_API_URL_TARGET}${
      props?.multiple ? "uploadmultiplepdf" : "uploadpdf"
    }`,
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
    data: {
      filetype: props?.filetype,
      customerid: props?.fileData?.customerid,
      creditid: props?.fileData?.creditid,
      loan_tender_id: props?.fileData?.loan_tender_id,
      loanname: props?.fileData?.loanname,
    },
    onChange(info) {
      if (info.file.status == "uploading") {
        setFileLoading(true);
      }
      if (info.file.status === "done") {
        setFileLoading(false);
        props?.getLoanData();
        message.success(`${info.file.name} file uploaded successfully`);
      }
      if (info.file.status === "error") {
        setFileLoading(false);
        message.error(info?.file?.response?.message);
      }
    },
    showUploadList: false,
    multiple: props?.multiple,
  };

  if (props?.userRole) {
    return (
      <Tooltip title={TranslateString("upload")}>
        <Upload {...propsFile}>
          {fileLoading ? (
            <LoadingOutlined />
          ) : (
            <UploadOutlined className="fs-5 pb-1" />
          )}
        </Upload>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title={TranslateString("download")}>
        <a
          href={props?.adorContract || ""}
          style={{ color: "inherit" }}
          rel="noreferrer"
          target="_blank"
          download
        >
          <DownloadOutlined className="fs-5 pb-1" />
        </a>
      </Tooltip>
    );
  }
};

const SingleLoanViewTwo = (props: any) => {
  const intl = useIntl();

  // const [deletePreviewVisible, setDeletePreviewVisible] = useState(false);
  // const [deletePreviewUrl, setDeletePreviewUrl] = useState<string>("");
  // const [deletePreviewTitle, setDeletePreviewTitle] = useState<string>("");
  // const [fileToDelete, setFileToDelete] = useState<any>(null);
  // const [deleteLoading, setDeleteLoading] = useState(false);
  // const [multiplePreviews, setMultiplePreviews] = useState<
  //   { url: string; title: string; file: any }[]
  // >([]);

  // const openDeletePreview = async (files: any[]) => {
  //   if (!files || files.length === 0) return;
  //   setMultiplePreviews([]);
  //   setDeletePreviewUrl("");
  //   setFileToDelete(null);

  //   if (files.length === 1) {
  //     const file = files[0];
  //     setFileToDelete(file);
  //     setDeleteLoading(true);
  //     setDeletePreviewVisible(true);
  //     setDeletePreviewTitle("Loading...");

  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL_TARGET}downloadpdf?loan_status_id=${file.loan_status_id}`,
  //         { headers: { Authorization: `Bearer ${UserService.getToken()}` } }
  //       );
  //       const result = await response.json();
  //       if (result.code !== 200 || !result.file) throw new Error();

  //       let base64String = result.file.trim();
  //       if (base64String.includes(","))
  //         base64String = base64String.split(",")[1];
  //       const originalName = result.data?.originalName || "document";
  //       const ext = originalName.split(".").pop()?.toLowerCase() || "";
  //       let mimeType = "application/pdf";
  //       if (
  //         ["jpg", "jpeg", "png", "gif", "webp", "jfif", "bmp", "svg"].includes(
  //           ext
  //         )
  //       ) {
  //         mimeType =
  //           ext === "jpg" || ext === "jpeg" || ext === "jfif"
  //             ? "image/jpeg"
  //             : `image/${ext}`;
  //       }

  //       const byteChars = atob(base64String);
  //       const byteNumbers = new Array(byteChars.length);
  //       for (let i = 0; i < byteChars.length; i++)
  //         byteNumbers[i] = byteChars.charCodeAt(i);
  //       const byteArray = new Uint8Array(byteNumbers);
  //       const blob = new Blob([byteArray], { type: mimeType });
  //       const url = URL.createObjectURL(blob);

  //       setDeletePreviewUrl(url);
  //       setDeletePreviewTitle(originalName);
  //     } catch {
  //       message.error("Failed to load preview");
  //       setDeletePreviewVisible(false);
  //     } finally {
  //       setDeleteLoading(false);
  //     }
  //     return;
  //   }

  //   setDeletePreviewVisible(true);
  //   setDeleteLoading(true);
  //   setDeletePreviewTitle(`${files.length} files`);

  //   const previews: { url: string; title: string; file: any }[] = [];

  //   try {
  //     await Promise.all(
  //       files.map(async (file: any) => {
  //         try {
  //           const response = await fetch(
  //             `${process.env.REACT_APP_API_URL_TARGET}downloadpdf?loan_status_id=${file.loan_status_id}`,
  //             { headers: { Authorization: `Bearer ${UserService.getToken()}` } }
  //           );
  //           const result = await response.json();
  //           if (result.code !== 200 || !result.file) return;

  //           let base64String = result.file.trim();
  //           if (base64String.includes(","))
  //             base64String = base64String.split(",")[1];
  //           const originalName = result.data?.originalName || "file.pdf";
  //           const ext = originalName.split(".").pop()?.toLowerCase() || "";
  //           let mimeType = "application/pdf";
  //           if (["jpg", "jpeg", "png", "gif", "webp", "jfif"].includes(ext)) {
  //             mimeType =
  //               ext === "jpg" || ext === "jpeg" || ext === "jfif"
  //                 ? "image/jpeg"
  //                 : `image/${ext}`;
  //           }

  //           const byteChars = atob(base64String);
  //           const byteNumbers = new Array(byteChars.length);
  //           for (let i = 0; i < byteChars.length; i++)
  //             byteNumbers[i] = byteChars.charCodeAt(i);
  //           const byteArray = new Uint8Array(byteNumbers);
  //           const blob = new Blob([byteArray], { type: mimeType });
  //           const url = URL.createObjectURL(blob);

  //           previews.push({ url, title: originalName, file });
  //         } catch (err) {
  //           console.warn(
  //             "Failed to load preview for file:",
  //             file.loan_status_id,
  //             err
  //           );
  //         }
  //       })
  //     );

  //     setMultiplePreviews(previews);
  //   } finally {
  //     setDeleteLoading(false);
  //   }
  // };

  // const confirmDelete = async () => {
  //   if (!fileToDelete?.loan_status_id) {
  //     message.error("No file selected");
  //     return;
  //   }

  //   Modal.confirm({
  //     title: "Delete this file permanently?",
  //     icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
  //     content: (
  //       <div>
  //         <small style={{ color: "#8c8c8c" }}>
  //           This action cannot be undone.
  //         </small>
  //       </div>
  //     ),
  //     okText: "Yes",
  //     okType: "danger",
  //     cancelText: "No",
  //     centered: true,
  //     okButtonProps: { loading: deleteLoading },
  //     onOk: async () => {
  //       setDeleteLoading(true);

  //       try {
  //         const response = await fetch(
  //           `${process.env.REACT_APP_API_URL_TARGET}delete_docs/${fileToDelete.loan_status_id}`,
  //           {
  //             method: "DELETE",
  //             headers: {
  //               Authorization: `Bearer ${UserService.getToken()}`,
  //             },
  //           }
  //         );

  //         if (!response.ok) {
  //           const errorData = await response.json().catch(() => ({}));
  //           throw new Error(errorData.message || "Failed to delete");
  //         }

  //         message.success("File deleted successfully");

  //         if (deletePreviewUrl) {
  //           URL.revokeObjectURL(deletePreviewUrl);
  //           setDeletePreviewUrl("");
  //         }

  //         setMultiplePreviews((prev) =>
  //           prev.filter(
  //             (p) => p.file.loan_status_id !== fileToDelete.loan_status_id
  //           )
  //         );
  //         setDeletePreviewVisible(false);
  //         props?.getLoanData?.();
  //       } catch (err: any) {
  //         console.error("Delete error:", err);
  //         message.error(
  //           err.message || "Failed to delete file. Please try again."
  //         );
  //       } finally {
  //         setDeleteLoading(false);
  //       }
  //     },
  //   });
  // };

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [filesForDelete, setFilesForDelete] = useState<any[]>([]);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [loadingNames, setLoadingNames] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // const openTestModal = () => {
  //   setFilesForDelete(mockFiles);
  //   setSelectedIds([]);
  //   setDeleteModalVisible(true);
  // };
  // TEMP MOCK DATA for UI testing
  // const mockFiles = [
  //   {
  //     loan_status_id: 101,
  //     originalName: "Invoice_January.pdf",
  //   },
  //   {
  //     loan_status_id: 102,
  //     originalName: "PassportPhoto.png",
  //   },
  //   {
  //     loan_status_id: 103,
  //     originalName: "BankStatement.pdf",
  //   },
  //   {
  //     loan_status_id: 104,
  //     originalName: "HouseImage.jpeg",
  //   },
  //   {
  //     loan_status_id: 105,
  //     originalName: "Document_Scan.jpg",
  //   },
  // ];

  const openDeleteModal = async (rawFiles: any[]) => {
    if (!rawFiles || rawFiles.length === 0) {
      message.info("No files to delete");
      return;
    }

    setLoadingNames(true);
    setDeleteModalVisible(true);
    setSelectedIds([]);

    try {
      const enrichedFiles = await Promise.all(
        rawFiles.map(async (file: any) => {
          try {
            const res = await fetch(
              `${process.env.REACT_APP_API_URL_TARGET}downloadpdf?loan_status_id=${file.loan_status_id}`,
              {
                headers: {
                  Authorization: `Bearer ${UserService.getToken()}`,
                },
              },
            );

            const json = await res.json();

            if (json.code === 200 && json.data?.originalName) {
              return {
                ...file,
                originalName: json.data.originalName, // Real name from backend
              };
            }
          } catch (err) {
            console.warn("Failed to fetch name for ID:", file.loan_status_id);
          }

          // Fallback if API fails
          return {
            ...file,
            originalName: `File_${file.loan_status_id}.pdf`,
          };
        }),
      );

      setFilesForDelete(enrichedFiles);
    } catch (err) {
      message.error("Failed to load file names");
      setDeleteModalVisible(false);
    } finally {
      setLoadingNames(false);
    }
  };

  // PERFORM DELETE
  const performDelete = async () => {
    // console.log(
    //   "DELETE CLICK PAYLOAD (JSON):",
    //   JSON.stringify({ ids: selectedIds }, null, 2)
    // );

    if (selectedIds.length === 0) return;

    Modal.confirm({
      title: `Permanently delete ${selectedIds.length} file(s)?`,
      icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
      content: (
        <span style={{ color: "#666" }}>This action cannot be undone.</span>
      ),
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "No",
      centered: true,
      onOk: async () => {
        // console.log("DELETE PAYLOAD:", { ids: selectedIds });
        setDeleteLoading(true);
        try {
          console.log(" PAYLOAD SENT TO BACKEND:", {
            ids: selectedIds,
          });
          const res = await fetch(
            `${process.env.REACT_APP_API_URL_TARGET}delete_docs`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${UserService.getToken()}`,
              },
              body: JSON.stringify({ ids: selectedIds }),
            },
          );

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.message || "Delete failed");
          }

          message.success(`${selectedIds.length} file(s) deleted successfully`);
          setDeleteModalVisible(false);
          setSelectedIds([]);
          props?.getLoanData?.();
        } catch (err: any) {
          message.error(err.message || "Failed to delete files");
        } finally {
          setDeleteLoading(false);
        }
      },
    });
  };
  const [noteError, setNoteError] = useState("");

  const [invoicingChanged, setInvoicingChanged] = useState(false);
  const [invoicingLoading, setInvoicingLoading] = useState(false);

  //checkbox
  // useEffect(() => {
  //   if (props?.loanData?.loan_tender_id) {
  //     props.setSaveData((prev: any) => ({
  //       ...prev,
  //       loan_invoicing_model: undefined,
  //     }));
  //   }
  // }, [props?.loanData?.loan_tender_id]);

  // useEffect(() => {
  //   if (
  //     props?.loanData?.loan_invoicing_model &&
  //     !props?.saveData?.loan_invoicing_model
  //   ) {
  //     props.setSaveData((prev: any) => ({
  //       ...prev,
  //       loan_invoicing_model: props.loanData.loan_invoicing_model,
  //       loan_tender_id: props.loanData.loan_tender_id,
  //       loan_credit_id: props.loanData.loan_data_credit_id,
  //     }));
  //   }
  // }, [props?.loanData]);

  useEffect(() => {
    // console.log("REAL VALUE:", props?.loanData?.LOAN_DATA?.loan_invoicing_model);

    if (!props?.loanData?.LOAN_DATA) return;

    props.setSaveData((prev: any) => ({
      ...prev,
      loan_invoicing_model: props.loanData.LOAN_DATA.loan_invoicing_model,
      loan_tender_id: props.loanData.loan_tender_id,
      loan_credit_id: props.loanData.loan_data_credit_id,
    }));
  }, [props?.loanData]);

  const onChange = (index: any, bank: any, event: any) => {
    let valCheck = event.target.checked;
    if (bank.bank_id == "select_all") {
      let bankCheckAll = props?.bankList;
      bankCheckAll = bankCheckAll.map((val: any) => {
        return val.map((bankVal: any) => {
          return { ...bankVal, checked: valCheck };
        });
      });
      props.setBankList(bankCheckAll);
    } else {
      let bankCheck = props?.bankList;
      bankCheck = bankCheck.map((val: any, ind: any) => {
        if (index == ind) {
          return val.map((bankVal: any) => {
            if (bankVal.bank_id == bank.bank_id) {
              return { ...bank, checked: !bank["checked"] };
            } else {
              return bankVal;
            }
          });
        } else {
          return val;
        }
      });
      props.setBankList(bankCheck);
    }
  };

  return (
    <>
      <Row>
        <Col sm={props?.type == "manager" ? 6 : 4}>
          <div
            className="mt-4 cu-table-border"
            style={{ height: "" }}
            ref={props.targetRef}
          >
            <table className="table table-sm table-bordered mb-0 cu-text-small">
              <thead className="cu-bg-subgreen">
                <tr className="cu-bg-green">
                  <td colSpan={3} className="text-left cu-text-large fw-bold">
                    <div className="d-flex">
                      <div className="ms-2">{TranslateString("files")}</div>

                      {props?.loanData?.date_last_refresh &&
                        props?.userRole && (
                          <div className="ms-auto">
                            <div className=" d-flex justify-content-between align-items-center cu-text-small mt-1">
                              <div>
                                <Tooltip
                                  title={TranslateString("date_last_refresh")}
                                >
                                  <ReloadOutlined role={"button"} />
                                </Tooltip>
                                &emsp;{TranslateString("date_last_refresh")}
                              </div>
                              &emsp;
                              <div>:</div>&emsp;
                              <div
                                style={{
                                  minWidth: "70px",
                                }}
                              >
                                {moment(
                                  props?.loanData?.date_last_refresh,
                                ).format("DD.MM.YYYY") || ""}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                {
                  <>
                    <tr
                      className="text-left cu-table-bg-lightgreen"
                      key={Math.random()}
                    >
                      <td>
                        {props?.userRole && (
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.ador_analysis}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                ador_analysis: !props.filesCheck?.ador_analysis,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                        )}
                        {props?.userRole
                          ? TranslateString("ador_analysis")
                          : TranslateString("marketing_materials")}
                      </td>
                      <td className="text-center" role="button">
                        <div className="d-flex">
                          <div>
                            {props?.userRole && (
                              <Tooltip title={TranslateString("view")}>
                                <Link
                                  to={
                                    `/generate-pdf/` +
                                    props?.id +
                                    "/" +
                                    props?.saveData?.loan_data_id
                                  }
                                  className="mr-1"
                                  style={{ color: "inherit" }}
                                  target="_blank"
                                >
                                  <EyeOutlined className="fs-5" />
                                </Link>
                              </Tooltip>
                            )}

                            {!props?.userRole && (
                              <Tooltip title={TranslateString("download")}>
                                <a
                                  href={props?.marketingMaterials || ""}
                                  style={{ color: "inherit" }}
                                  rel="noreferrer"
                                  target="_blank"
                                  download
                                >
                                  <DownloadOutlined className="fs-5" />
                                </a>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {!props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>{TranslateString("contracts")}</td>
                        <td className="text-center" role="button">
                          <div className="d-flex">
                            {props?.saveData?.attachment_ids?.map(
                              (val: any) => {
                                if (val.loan_status_doc_type == "contract") {
                                  return (
                                    <>
                                      <div>
                                        <a
                                          className="cu-color-right"
                                          href="javascript:void(0)"
                                          onClick={() => {
                                            props?.downloadBlobFile(
                                              val?.loan_status_id,
                                            );
                                          }}
                                          rel="noopener noreferrer"
                                        >
                                          <Tooltip
                                            title={TranslateString("view")}
                                          >
                                            <EyeOutlined className="fs-5 pt-1" />
                                          </Tooltip>
                                        </a>
                                      </div>
                                      <div>&nbsp;</div>
                                    </>
                                  );
                                }
                              },
                            )}

                            <div>
                              <FileHandle
                                {...props}
                                filetype={"contract"}
                                multiple={false}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.share_analysis}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                share_analysis:
                                  !props.filesCheck?.share_analysis,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                          {TranslateString("Shareholder")}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex">
                            <div>
                              <Tooltip title={TranslateString("view")}>
                                <Link
                                  to={`/list-of-shareholder-pdf/` + props?.id}
                                  style={{ color: "inherit" }}
                                  target="_blank"
                                >
                                  <EyeOutlined className="fs-5" />
                                </Link>
                              </Tooltip>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.property_certificate}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                property_certificate:
                                  !props.filesCheck?.property_certificate,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                          {TranslateString(
                            "allekirjoitettu_tilinpaatos_ja_toimintaketomus",
                          )}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex align-items-center gap-1">
                            {props?.saveData?.attachment_ids?.some(
                              (val: any) =>
                                val.loan_status_doc_type ==
                                "property_certificate",
                            ) && (
                              <>
                                <div>
                                  <a
                                    className="cu-color-right"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                      props?.downloadBlobFile(
                                        props?.saveData?.attachment_ids?.find(
                                          (val: any) =>
                                            val?.loan_status_doc_type ==
                                            "property_certificate",
                                        )?.loan_status_id,
                                      );
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    <Tooltip title={TranslateString("view")}>
                                      <EyeOutlined className="fs-5 pt-1" />
                                    </Tooltip>
                                  </a>
                                </div>
                                <div>&nbsp;</div>
                              </>
                            )}
                            <div>
                              <FileHandle
                                {...props}
                                filetype={"property_certificate"}
                                multiple={false}
                              />
                            </div>

                            {props?.userRole &&
                              props?.saveData?.attachment_ids?.some(
                                (f: any) =>
                                  f.loan_status_doc_type ===
                                  "property_certificate",
                              ) && (
                                <Tooltip title={TranslateString("Delete")}>
                                  <CloseSquareOutlined
                                    className="fs-6 text-danger ms-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      openDeleteModal(
                                        props?.saveData?.attachment_ids?.filter(
                                          (f: any) =>
                                            f.loan_status_doc_type ===
                                            "property_certificate",
                                        ),
                                      )
                                    }
                                    // onClick={() => openTestModal()}
                                  />
                                </Tooltip>
                              )}
                          </div>
                        </td>
                      </tr>
                    )}
                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.accounting_data}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                accounting_data:
                                  !props.filesCheck?.accounting_data,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                          {TranslateString("isannoitijantodistu")}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex align-items-center gap-1">
                            {props?.saveData?.attachment_ids?.some(
                              (val: any) =>
                                val.loan_status_doc_type == "accounting_data",
                            ) && (
                              <>
                                {" "}
                                <div>
                                  <a
                                    className="cu-color-right"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                      props?.downloadBlobFile(
                                        props?.saveData?.attachment_ids?.find(
                                          (val: any) =>
                                            val?.loan_status_doc_type ==
                                            "accounting_data",
                                        )?.loan_status_id,
                                      );
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    <Tooltip title={TranslateString("view")}>
                                      <EyeOutlined className="fs-5 pt-1" />
                                    </Tooltip>
                                  </a>
                                </div>{" "}
                                <div>&nbsp;</div>
                              </>
                            )}
                            <div>
                              <FileHandle
                                {...props}
                                filetype={"accounting_data"}
                                multiple={false}
                              />
                            </div>
                            {props?.userRole &&
                              props?.saveData?.attachment_ids?.some(
                                (f: any) =>
                                  f.loan_status_doc_type === "accounting_data",
                              ) && (
                                <Tooltip title={TranslateString("Delete")}>
                                  <CloseSquareOutlined
                                    className="fs-6 text-danger ms-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      openDeleteModal(
                                        props?.saveData?.attachment_ids?.filter(
                                          (f: any) =>
                                            f.loan_status_doc_type ===
                                            "accounting_data",
                                        ),
                                      )
                                    }
                                    // onClick={() => openDeletePreview([])}
                                  />
                                </Tooltip>
                              )}
                          </div>
                        </td>
                      </tr>
                    )}
                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.energy_certificate}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                energy_certificate:
                                  !props.filesCheck?.energy_certificate,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                          {TranslateString("energy_certificate")}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex align-items-center gap-1">
                            {props?.saveData?.attachment_ids?.some(
                              (val: any) =>
                                val.loan_status_doc_type ==
                                "energy_certificate",
                            ) && (
                              <>
                                {" "}
                                <div>
                                  <a
                                    className="cu-color-right"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                      props?.downloadBlobFile(
                                        props?.saveData?.attachment_ids?.find(
                                          (val: any) =>
                                            val?.loan_status_doc_type ==
                                            "energy_certificate",
                                        )?.loan_status_id,
                                      );
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    <Tooltip title={TranslateString("view")}>
                                      <EyeOutlined className="fs-5 pt-1" />
                                    </Tooltip>
                                  </a>
                                </div>
                                <div>&nbsp;</div>
                              </>
                            )}
                            <div>
                              <FileHandle
                                {...props}
                                filetype={"energy_certificate"}
                                multiple={false}
                              />
                            </div>
                            {props?.userRole &&
                              props?.saveData?.attachment_ids?.some(
                                (f: any) =>
                                  f.loan_status_doc_type ===
                                  "energy_certificate",
                              ) && (
                                <Tooltip title={TranslateString("Delete")}>
                                  <CloseSquareOutlined
                                    className="fs-6 text-danger ms-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      openDeleteModal(
                                        props?.saveData?.attachment_ids?.filter(
                                          (f: any) =>
                                            f.loan_status_doc_type ===
                                            "energy_certificate",
                                        ),
                                      )
                                    }
                                    // onClick={() => openDeletePreview([])}
                                  />
                                </Tooltip>
                              )}
                          </div>
                        </td>
                      </tr>
                    )}

                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen"
                        key={Math.random()}
                      >
                        <td>
                          <Checkbox
                            className="pr-2"
                            checked={props?.filesCheck?.additional_attachment}
                            onChange={() =>
                              props?.setFilesCheck({
                                ...props?.filesCheck,
                                additional_attachment:
                                  !props.filesCheck?.additional_attachment,
                              })
                            }
                            disabled={props?.tenderCase === "close"}
                          />
                          {TranslateString("additional_attachment")}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex align-items-center gap-1">
                            {props?.saveData?.attachment_ids?.some(
                              (val: any) =>
                                val.loan_status_doc_type ==
                                "additional_attachment",
                            ) && (
                              <>
                                {props?.saveData?.attachment_ids
                                  ?.filter(
                                    (val: any) =>
                                      val.loan_status_doc_type ==
                                      "additional_attachment",
                                  )
                                  ?.map((foo: any) => {
                                    return (
                                      <>
                                        <div>
                                          <a
                                            className="cu-color-right"
                                            href="javascript:void(0)"
                                            onClick={() => {
                                              props?.downloadBlobFile(
                                                foo?.loan_status_id,
                                              );
                                            }}
                                            rel="noopener noreferrer"
                                          >
                                            <Tooltip
                                              title={TranslateString("view")}
                                            >
                                              <EyeOutlined className="fs-5 pt-1" />
                                            </Tooltip>
                                          </a>
                                        </div>
                                        <div>&nbsp;</div>
                                      </>
                                    );
                                  })}
                              </>
                            )}
                            <div>
                              <FileHandle
                                {...props}
                                filetype={"additional_attachment"}
                                multiple={true}
                              />
                            </div>
                            {props?.userRole &&
                              props?.saveData?.attachment_ids?.some(
                                (f: any) =>
                                  f.loan_status_doc_type ===
                                  "additional_attachment",
                              ) && (
                                <Tooltip title={TranslateString("Delete")}>
                                  <CloseSquareOutlined
                                    className="fs-6 text-danger ms-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      openDeleteModal(
                                        props?.saveData?.attachment_ids?.filter(
                                          (f: any) =>
                                            f.loan_status_doc_type ===
                                            "additional_attachment",
                                        ),
                                      )
                                    }
                                    // onClick={() => openDeletePreview([])}
                                  />
                                </Tooltip>
                              )}
                          </div>
                        </td>
                      </tr>
                    )}

                    {props?.userRole && (
                      <tr
                        className="text-left cu-table-bg-lightgreen align-middle"
                        key={Math.random()}
                      >
                        <td className="lh-2">
                          {TranslateString("files_from_housing_manager")}
                        </td>
                        <td className="text-center" role="button">
                          <div className="d-flex">
                            {props?.saveData?.attachment_ids?.map(
                              (val: any) => {
                                if (val.loan_status_doc_type == "contract") {
                                  return (
                                    <>
                                      <div>
                                        <a
                                          className="cu-color-right"
                                          href="javascript:void(0)"
                                          onClick={() => {
                                            props?.downloadBlobFile(
                                              val?.loan_status_id,
                                            );
                                          }}
                                          rel="noopener noreferrer"
                                        >
                                          <Tooltip
                                            title={TranslateString("view")}
                                          >
                                            <EyeOutlined className="fs-5 pt-1" />
                                          </Tooltip>
                                        </a>
                                      </div>
                                      <div>&nbsp;</div>
                                    </>
                                  );
                                }
                              },
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                }
              </tbody>
            </table>
          </div>
        </Col>
        {props?.type != "manager" && (
          <Col sm={4}>
            <div
              className="mt-4 cu-table-border cu-table-bg-lightgreen"
              style={{ height: props.dimensions?.height + "px" }}
            >
              <table className="table table-sm table-borderless mb-0 cu-text-small">
                <thead className="cu-bg-subgreen">
                  <tr className="cu-bg-green">
                    <td colSpan={3} className="text-left cu-text-large fw-bold">
                      <div className="ms-2">
                        {
                          <>
                            <span>
                              {TranslateString(
                                "banks_participating_this_tendering",
                              )}
                            </span>
                            <span className="text-danger">*</span>
                          </>
                        }
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody className="text-left">
                  {props?.bankList?.map((val: any, index: any) => {
                    return (
                      <tr>
                        {val?.map((bank: any) => {
                          return (
                            <td>
                              <Checkbox
                                className="p-2"
                                value={"select_all"}
                                checked={bank.checked}
                                onChange={(e) => onChange(index, bank, e)}
                                disabled={props?.tenderCase === "close"}
                              >
                                {bank?.bank_name == "Select all"
                                  ? TranslateString("select_all")
                                  : bank?.bank_name}
                              </Checkbox>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Col>
        )}
        {props?.type != "manager" && (
          <Col sm={4}>
            <div className="mt-4 mr-2">
              <Card className="bg-light">
                <div className="row m-1">
                  <div className="col-lg-12 col-md-8 col-sm-12 m-1">
                    <table width="100%">
                      <tr>
                        <td className="text-left pb-2">
                          <label
                            htmlFor="deadlineForQuotation"
                            className="fw-bold text-nowrap align-top"
                          >
                            {
                              <>
                                <span>
                                  {TranslateString("Deadline for quotation")}
                                </span>
                                <span className="text-danger">*</span>
                              </>
                            }
                          </label>
                        </td>
                        <td>&nbsp;&emsp;</td>
                      </tr>
                      <tr>
                        <td className="text-left pb-2">
                          <ConfigProvider
                            locale={intl.locale === "en" ? localeEN : localeFI}
                          >
                            <DatePicker
                              defaultValue={
                                props?.saveData?.tender_req_deadline
                              }
                              format={"DD.MM.YYYY"}
                              disabledDate={(current) => {
                                let customDate = moment().format("YYYY-MM-DD");
                                return (
                                  current &&
                                  current < moment(customDate, "YYYY-MM-DD")
                                );
                              }}
                              id="deadlineForQuotation"
                              className="w-100"
                              onChange={(val) => {
                                props.setSaveData({
                                  ...props?.saveData,
                                  tender_req_deadline: val,
                                });
                              }}
                              value={props?.saveData?.tender_req_deadline}
                              disabled={props?.tenderCase === "close"}
                            />
                          </ConfigProvider>
                        </td>
                        <td>&nbsp;&emsp;</td>
                        <td className="text-right mb-2">
                          <button
                            onClick={() => {
                              props?.setOpenV2(true);
                            }}
                            className="btn btn-sm cu-btn-green px-3 py-1"
                            disabled={
                              props?.loanData?.loan_tender_status ==
                                "potential" || !props?.changeDeadline
                                ? true
                                : props?.tenderCase === "close"
                            }
                          >
                            {TranslateString("change_deadline")}
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-left text-left pb-2">
                          <label
                            htmlFor="notes"
                            className="fw-bold text-nowrap align-top"
                          >
                            {TranslateString("Notes")}
                          </label>
                        </td>
                        <td>&nbsp;&emsp;</td>
                      </tr>

                      <tr>
                        <td className="">
                          <Input.TextArea
                            rows={2}
                            onChange={(e) => props?.onNotesChange(e)}
                            value={props?.saveData?.tender_req_notes}
                            id="notes"
                            disabled={props?.tenderCase === "close"}
                            onKeyDown={(e) => {
                              if (e.key === ";") {
                                e.preventDefault();
                                setNoteError(
                                  "Note: 'semicolon' is not allowed.",
                                );
                                setTimeout(() => {
                                  setNoteError("");
                                }, 3000);
                              }
                            }}
                            status={noteError ? "error" : ""}
                          />
                          {noteError && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {noteError}
                            </span>
                          )}
                        </td>
                        <td>&nbsp;&emsp;</td>
                      </tr>
                      <tr className="text-left">
                        {/* <td className="text-right"><button onClick={() => { props?.setOpen(true) }} className="btn btn-sm cu-btn-green px-3 py-1" disabled={props?.loanData?.loan_tender_status == "potential" ? true : false}>{TranslateString('change_deadline')}</button></td> */}
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <button
                            onClick={() => {
                              props?.setOpen(true);
                            }}
                            className="btn btn-sm cu-btn-green px-3 py-1"
                            disabled={
                              props?.loanData?.loan_tender_status == "potential"
                                ? true
                                : props?.tenderCase === "close"
                            }
                          >
                            {TranslateString("send")}
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </Card>
              <Card className="bg-light">
                <div className="row m-1">
                  <div className="col-lg-12 col-md-8 col-sm-12 m-1">
                    <table width="100%">
                      <tr>
                        <td className="text-left pb-2">
                          <label className="fw-bold text-nowrap">
                            {TranslateString("loan_invoicing_model")}
                          </label>
                        </td>
                        <td>&nbsp;&emsp;</td>
                      </tr>

                      {/* <tr>
                        <td>
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            <Checkbox
                              checked={
                                props?.saveData?.loan_invoicing_model ===
                                "Recurring"
                              }
                              onChange={() => {
                                props.setSaveData({
                                  ...props.saveData,
                                  loan_invoicing_model: "Recurring",
                                });
                                setInvoicingChanged(true);
                              }}
                              disabled={props?.tenderCase === "close"}
                            >
                              <span style={{ whiteSpace: "nowrap" }}>
                                {intl.formatMessage({ id: "Recurring" })}
                              </span>
                            </Checkbox>

                            <Checkbox
                              checked={
                                props?.saveData?.loan_invoicing_model ===
                                "Non-Recurring"
                              }
                              onChange={() => {
                                props.setSaveData({
                                  ...props.saveData,
                                  loan_invoicing_model: "Non-Recurring",
                                });
                                setInvoicingChanged(true);
                              }}
                              disabled={props?.tenderCase === "close"}
                            >
                              <span style={{ whiteSpace: "nowrap" }}>
                                {intl.formatMessage({ id: "Non-Recurring" })}
                              </span>
                            </Checkbox>

                            <button
                              className="btn btn-sm cu-btn-green px-2 py-1"
                               
                              
                              disabled={invoicingLoading}
                              onClick={async () => {
                                if (!invoicingChanged) {
                                  message.info("No changes to save");
                                  return;
                                }

                                try {
                                  setInvoicingLoading(true);

                                  const res = await fetch(
                                    `${process.env.REACT_APP_API_URL_TARGET}save_tender_invoicing_model`,
                                    {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${UserService.getToken()}`,
                                      },
                                      body: JSON.stringify({
                                        loan_tender_id:
                                          props.saveData.loan_tender_id,
                                          loan_credit_id: props.saveData.loan_credit_id,
                                        loan_invoicing_model:
                                          props.saveData
                                            .loan_invoicing_model,
                                      }),
                                    },
                                  );

                                  if (!res.ok) {
                                    const err = await res
                                      .json()
                                      .catch(() => ({}));
                                    throw new Error(
                                      err.message || "Update failed",
                                    );
                                  }

                                  message.success(
                                    // "Invoicing model updated successfully",
                                    intl.formatMessage({ id: "Invoicing model updated successfully" })
                                  );
                                  setInvoicingChanged(false);
                                } catch (err: any) {
                                  message.error(
                                    err.message ||
                                      // "Failed to update invoicing model",
                                      intl.formatMessage({ id: "Failed to update invoicing model" })
                                  );
                                } finally {
                                  setInvoicingLoading(false);
                                }
                              }}
                            >
                              {invoicingLoading ? "..." : intl.formatMessage({ id: "save" })}
                            </button>
                          </div>
                        </td>
                        <td>&nbsp;&emsp;</td>
                      </tr> */}
                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            <Checkbox
                              checked={
                                props?.saveData?.loan_invoicing_model ===
                                "Recurring"
                              }
                              onChange={() => {
                                props.setSaveData({
                                  ...props.saveData,
                                  loan_invoicing_model: "Recurring",
                                });
                                setInvoicingChanged(true);
                              }}
                              disabled={props?.tenderCase === "close"}
                            >
                              <span style={{ whiteSpace: "nowrap" }}>
                                {intl.formatMessage({ id: "Recurring" })}
                              </span>
                            </Checkbox>

                            <Checkbox
                              checked={
                                props?.saveData?.loan_invoicing_model ===
                                "Non-Recurring"
                              }
                              onChange={() => {
                                props.setSaveData({
                                  ...props.saveData,
                                  loan_invoicing_model: "Non-Recurring",
                                });
                                setInvoicingChanged(true);
                              }}
                              disabled={props?.tenderCase === "close"}
                            >
                              <span style={{ whiteSpace: "nowrap" }}>
                                {intl.formatMessage({ id: "Non-Recurring" })}
                              </span>
                            </Checkbox>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-right pt-2">
                          <button
                            className="btn btn-sm cu-btn-green px-3 py-1"
                            disabled={invoicingLoading}
                            onClick={async () => {
                              if (!invoicingChanged) {
                                message.info("No changes to save");
                                return;
                              }

                              try {
                                setInvoicingLoading(true);

                                const res = await fetch(
                                  `${process.env.REACT_APP_API_URL_TARGET}save_tender_invoicing_model`,
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: `Bearer ${UserService.getToken()}`,
                                    },
                                    body: JSON.stringify({
                                      loan_tender_id:
                                        props.saveData.loan_tender_id,
                                      loan_credit_id:
                                        props.saveData.loan_credit_id,
                                      loan_invoicing_model:
                                        props.saveData.loan_invoicing_model,
                                      loan_data_name:
                                        props.loanData?.loan_data_name,
                                      loan_data_customerid:
                                        props.loanData?.loan_data_customerid,
                                      loan_data_credit_id:
                                        props.loanData?.loan_data_credit_id,
                                    }),
                                  },
                                );

                                if (!res.ok) {
                                  const err = await res
                                    .json()
                                    .catch(() => ({}));
                                  throw new Error(
                                    err.message || "Update failed",
                                  );
                                }

                                message.success(
                                  intl.formatMessage({
                                    id: "Invoicing model updated successfully",
                                  }),
                                );
                                setInvoicingChanged(false);
                              } catch (err: any) {
                                message.error(
                                  err.message ||
                                    intl.formatMessage({
                                      id: "Failed to update invoicing model",
                                    }),
                                );
                              } finally {
                                setInvoicingLoading(false);
                              }
                            }}
                          >
                            {invoicingLoading
                              ? "..."
                              : intl.formatMessage({ id: "save" })}
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        )}
      </Row>
      <Modal
        open={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={null}
        width={720}
        title={
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold text-gray-800 m-0">Attachments</h2>
          </div>
        }
        closeIcon={<CloseOutlined style={{ fontSize: 18, color: "#555" }} />}
        destroyOnClose
        bodyStyle={{ padding: "16px 24px 20px" }}
        maskClosable={false}
      >
        <Table
          dataSource={filesForDelete}
          // rowKey="loan_status_id"
          rowKey={(record) => Number(record.loan_status_id)}
          loading={{
            spinning: loadingNames,
            tip: "Loading file ...",
            size: "large",
          }}
          pagination={false}
          size="small"
          bordered={false}
          rowSelection={{
            // selectedRowKeys: selectedIds,
            selectedRowKeys: selectedIds.map(Number),
            // onChange: (keys) => setSelectedIds(keys as number[]),
            onChange: (keys) => setSelectedIds(keys.map(Number)),
          }}
          locale={{ emptyText: "No files available" }}
          style={{ marginBottom: 16 }}
        >
          <Table.Column
            title="File"
            render={(_, record: any) => {
              const name = record.originalName || "Unknown file";
              const ext = name.split(".").pop()?.toLowerCase();
              const isPdf = ext === "pdf";
              const isImage = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "webp",
                "jfif",
              ].includes(ext || "");

              return (
                <Space size={10}>
                  {isPdf ? (
                    <FilePdfOutlined
                      style={{ fontSize: 22, color: "#f5222d" }}
                    />
                  ) : isImage ? (
                    <FileImageOutlined
                      style={{ fontSize: 22, color: "#1890ff" }}
                    />
                  ) : (
                    <FileOutlined style={{ fontSize: 22, color: "#8c8c8c" }} />
                  )}
                  <span
                    className="text-sm font-medium text-gray-800 truncate max-w-[380px]"
                    title={name}
                  >
                    {name}
                  </span>
                </Space>
              );
            }}
          />
        </Table>

        <div className="flex justify-end">
          <Button
            type="primary"
            danger
            size="middle"
            onClick={performDelete}
            disabled={selectedIds.length === 0}
            loading={deleteLoading}
            className="font-medium"
            style={{
              borderRadius: 8,
              minWidth: 150,
              height: 40,
              boxShadow:
                selectedIds.length > 0
                  ? "0 4px 12px rgba(245, 34, 45, 0.3)"
                  : "none",
              paddingInline: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <CloseSquareOutlined style={{ fontSize: 16 }} />
              Delete File
            </span>
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default SingleLoanViewTwo;
